import { Button } from "@mui/material";

import { className } from "utils/strings";

import { ReactComponent as ActiveIcon } from "components/icons/FooterIcons/exploreIconActive.svg";
import { ReactComponent as InActiveIcon } from "components/icons/FooterIcons/exploreIconInactive.svg";

import "./buttons.scss";

export const ExploreButton = (props: {
  active: boolean;
  onClick: () => void;
}): JSX.Element => {
  const Icon = props.active
    ? ActiveIcon
    : InActiveIcon;

  const onClick = () => {
    props.onClick();
  };

  return (
    <Button onClick={onClick} className={className({
      "saved": true,
      "active": props.active,
      "inactive": !props.active,
    })}>
      <Icon />
      <label>Explore</label>
    </Button>
  );
};
